import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import {
  AddNewCertificate,
  AddNewDirection,
  fetchAllData,
} from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function DirectionAdd({ directionAdd, setDirectionAdd }) {
  const [mainPhoto, setMainPhoto] = useState("");
  const [photoFile, setPhotoFile] = useState();
  const [mainPhoto2, setMainPhoto2] = useState("");
  const [photoFile2, setPhotoFile2] = useState();
  const [name, setName] = useState("");
  const [directions, setDirections] = useState("");
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto(reader.result);
    };
    setPhotoFile(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleFile2Change = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto2(reader.result);
    };
    setPhotoFile2(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const saveNewDirection = () => {
    dispatch(AddNewDirection({ name, directions, photoFile, photoFile2 }));

    setMainPhoto("");
    setMainPhoto2("");
    setPhotoFile("");
    setPhotoFile2("");
    setName("");
    toast.info("Adding Direction...", { autoClose: false });
    setDirectionAdd(false);
  };
  return (
    directionAdd && (
      <div className="direction-add-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setDirectionAdd(false)}
        ></div>
        <div className="container ">
          <div className="title">اضافه تعليمات جديده</div>
          <div className="group">
            {" "}
            <div className="image">
              <label htmlFor="add-image">
                <div className="title">الصور الاساسيه</div>
                <img
                  className={mainPhoto ? `` : ` none`}
                  src={mainPhoto ? `${mainPhoto}` : `/images/add.png`}
                  alt=""
                />
              </label>
              <input
                type="file"
                onChange={handleFileChange}
                name=""
                accept="image/*"
                id="add-image"
                style={{ display: "none" }}
              />
            </div>
            <div className="image">
              <label htmlFor="add-image2">
                <div className="title">الصور الثانيه</div>
                <img
                  className={mainPhoto2 ? `` : ` none`}
                  src={mainPhoto2 ? `${mainPhoto2}` : `/images/add.png`}
                  alt=""
                />
              </label>
              <input
                type="file"
                onChange={handleFile2Change}
                name=""
                accept="image/*"
                id="add-image2"
                style={{ display: "none" }}
              />
            </div>
          </div>
          <div className="text">
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <textarea
              type="text"
              placeholder="Directions"
              value={directions}
              onChange={(e) => setDirections(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => saveNewDirection()}>
            اضافه
          </div>
        </div>
      </div>
    )
  );
}
